import React from "react";
/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import { useEffect } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { useState, forwardRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import PointAdd from "./PointAdd";
import PointEdit from "./PointEdit";
import log from "../lib/log";
import { loginState, configState } from "../lib/State";
import token_login from "../lib/token_login";
import get_session from "../lib/get_session";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import { AppBar, Toolbar, IconButton } from "@mui/material";
import CenterSelect from "./CenterSelect";
import pr from "../lib/pr";
import get_login from "../lib/get_login";
import is_admin from "../lib/is_admin";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function PointLog() {
  const [login, setLogin] = useState(loginState);
  const [loaded, setLoaded] = useState(false);
  const [rows, setRows] = useState([]);
  const [seq, setSeq] = useState(-1);
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const token = localStorage.getItem("token");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [popPhone, setPopPhone] = useState("Hello");
  const [centers, setCenters] = useState([]);
  const [tcid, setTcid] = useState('');
  const [sname, setSname] = useState('');
  const [sphone, setSphone] = useState('');
  const open = Boolean(anchorEl);
  const [type, setType] = useState('');
  const point_category = [
    '심박포인트',
    '출석포인트',
    '캐시',
    '칼로리포인트'
  ]

  const columns = [
    { field: "id", headerName: "id", hide: true },
    { field: "regdate", headerName: "등록", width: 140, align: "center" },
    {
      field: "name",
      headerName: "이름",
      width: 110,
      renderCell: (params) => {
        return (
          <Typography
            sx={{ p: 1 }}
            onMouseEnter={(event) => onPopoverOver(event, params.row.phone)}
            onMouseOut={onPopoverOut}
          >
            {params.row.name}
          </Typography>
        );
      },
    },
    {
      field: "type",
      headerName: "구분",
      width: 140,
      align:"center"
    },
    {
      field: "title",
      headerName: "제목",
      width: 210,
      align:"center"
    },
    { field: "amount", headerName: "포인트", align: "center", width: 140 },
    { field: "total", headerName: "합계", align: "center", width: 140 },
    { field: "cname", headerName: "센터명", width: 180, align: "cname" },
  ];

  // const rows = [
  //   {
  //     id: 1,
  //     name: "Snow",
  //     phone: "000-0000-0000",
  //     sex: "남",
  //     age: 35,
  //     weight: 55,
  //   }
  // ];

  const onCloseAddPop = () => {
    setShowAdd(false);
    setTimeout(() => {
      window.location.reload();
    }, 300);
  };

  const onCloseEditPop = () => {
    setShowEdit(false);
    setTimeout(() => {
      window.location.reload();
    }, 300);
  };

  const onOpenAdd = () => {
    setShowAdd(true);
  };

  // 리스트
  const load_data = async () => {
    console.log("load_data");
    pr('tcid='+tcid);
    let result = await axios.post(configState.api + "/gympass_admin/point_log", {
      token: token,
      cid: login.cid,
      level: login.level,
      mcd: login.mcd,
      tcid: tcid,
      sname: sname,
      sphone: sphone,
      stype:type,
    });
    if (result.data.success === 1) {
      setRows(result.data.rows);
    } else {
      Swal.fire(result.data.msg);
      return;
    }
  };

  // ======================= //
  // 로그인
  // ======================= //
  const start = async () => {
    let result;
    result = await get_login();
    setLogin(result.data.login);
    result = await is_admin(result.data.login);
    if (!result) {
      window.location.href = "/";
    }
    setLoaded(true);
  };
  useEffect(() => {
    start();
  }, []);

  // 리스트
  useEffect(() => {    
    if (loaded && tcid !=='') {
      load_data();
    }
  }, [loaded, tcid]);

  // 팝업처리
  const onPopoverOver = (event, message) => {
    setPopPhone(message);
    setAnchorEl(event.currentTarget);
  };

  const onPopoverOut = (event) => {
    setAnchorEl(null);
  };

  const onSearchClick = async () => {
    load_data();
  };  

  return (
    <>
      {loaded === false ? (
        <Loading></Loading>
      ) : (
        <Layout login={login}>
          <Popover
            id="mouse-over-popover"
            sx={{
              pointerEvents: "none",
            }}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            onClose={onPopoverOut}
            disableRestoreFocus
          >
            <Typography sx={{ p: 1 }}>{popPhone}</Typography>
          </Popover>

          <h3
            css={css`
              margin-top: 10px;
            `}
          >
            포인트관리 (로그)
          </h3>
          
          <Box
            display="flex"
            css={css`
              text-align: right;
              max-width: 1300px;
              margin-bottom: 15px;
            `}
          >
           {/* 센터명 */}
           <CenterSelect                            
              login={login}
              tcidParent={tcid}
              setTcidParent={setTcid}
            />   
            <Box sx={{ flexGrow: 1 }}></Box>
          </Box>

          <Box display="flex" sx={{ mb:1 }}>
            {/* 이름 */}
            <Box>
              <TextField
                sx={{ width: 120 }}
                name="sname"
                label="이름"
                size="small"
                onChange={(e)=>setSname(e.target.value)}
                autoComplete="off"
              ></TextField>
            </Box>

            {/* 연락처 */}
            <Box>
              <TextField
                sx={{ width: 160, ml: 1 }}
                name="sphone"
                label="연락처"
                size="small"
                onChange={(e)=>setSphone(e.target.value)}
                autoComplete="off"
              ></TextField>
            </Box>

            {/* 포인트구분 */}
            <FormControl
              sx={{ml:1}}
            >
              <InputLabel id="demo-simple-select-label">포인트구분</InputLabel>
              <Select
                name="type"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                css={css`
                  width: 260px;
                `}
                label="포인트구분"
                size="small"
                value={type}
                onChange={(e) => setType(e.target.value)}
              >
                {point_category.map((item, index)=>{
                  return <MenuItem key={index} value={item}>{item}</MenuItem>
                })}
              </Select>
            </FormControl>


            <Button
              sx={{ ml: 1, fontSize:15 }}
              variant="contained"
              onClick={onSearchClick}
              size="small"
            >
              조회
            </Button>
          </Box> 

          <DataGrid
            css={css`
              max-width: 1300px;
              min-height: 500px;
            `}
            rows={rows}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[5]}
            checkboxSelection={false}             
          />

          <Dialog
            open={showAdd}
            fullWidth={true}
            maxWidth="md"
            TransitionComponent={Transition}
            onClose={() => {}}
          >
            <AppBar sx={{ position: "static" }}>
              <Toolbar>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography style={{ fontSize: 18 }}>포인트추가</Typography>
                </Box>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={onCloseAddPop}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Toolbar>
            </AppBar>
            <PointAdd
              login={login}
              onCloseAddPop={onCloseAddPop}
            ></PointAdd>
          </Dialog>

          <Dialog
            open={showEdit}
            TransitionComponent={Transition}
            onClose={() => {}}
            maxWidth="md"
          >
            <AppBar sx={{ position: "static" }}>
              <Toolbar>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography style={{ fontSize: 18 }}>포인트수정</Typography>
                </Box>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={onCloseEditPop}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Toolbar>
            </AppBar>
            <PointEdit
              login={login}
              seq={seq}
              onClosePop={onCloseEditPop}
            ></PointEdit>
          </Dialog>
        </Layout>
      )}
    </>
  );
}

export default PointLog;
